import * as React from "react";
import { Input } from "@/components/ui/input";
import { Search, X } from "lucide-react";
import { cn } from "@/lib/utils";

interface ClearableInputProps extends Omit<React.ComponentProps<"input">, "onChange"> {
  value: string;
  onChange: (value: string) => void;
  icon?: React.ElementType | null;
  wrapperClassName?: string;
}

const ClearableInput = React.forwardRef<HTMLInputElement, ClearableInputProps>(
  ({ value, onChange, icon: Icon = Search, className, wrapperClassName, ...props }, ref) => {
    const hasIcon = Icon != null;
    const showClear = value.length > 0;

    return (
      <div className={cn("relative", wrapperClassName)}>
        {hasIcon && (
          <Icon className="absolute left-2.5 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none" />
        )}
        <Input
          ref={ref}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className={cn(
            hasIcon && "pl-9",
            showClear && "pr-8",
            className,
          )}
          {...props}
        />
        {showClear && (
          <button
            type="button"
            onClick={() => onChange("")}
            className="absolute right-2.5 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        )}
      </div>
    );
  },
);

ClearableInput.displayName = "ClearableInput";

export { ClearableInput };
export type { ClearableInputProps };
